module.exports = __webpack_public_path__ + "img/bottom opening.03160960.png";